<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog
      v-model="dialogActivateInactivateCountry"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar dark dense class="elevation-0" color="primary">
          <v-icon small class="mr-2">{{
            StoreObj.country_status == "ACTIVE" ? "mdi-close" : "mdi-check"
          }}</v-icon>
          <div
            v-text="
              StoreObj.country_status == 'ACTIVE' ? 'Deactivate' : 'Activate'
            "
          ></div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogActivateInactivateCountryEmit((Toggle = 1))"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text align="center">
          <v-icon
            class="mt-5"
            size="50px"
            :color="StoreObj.country_status == 'ACTIVE' ? 'red' : 'green'"
            >{{
              StoreObj.country_status == "ACTIVE" ? "mdi-close" : "mdi-check"
            }}</v-icon
          >
          <div>
            Are you Sure you want to
            <span>{{
              StoreObj.country_status == "ACTIVE" ? "Deactivate" : "Activate"
            }}</span>
            {{ StoreObj.country_name }} ?
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius"
            color="secondary"
            outlined
            @click="dialogActivateInactivateCountryEmit((Toggle = 1))"
            ><v-icon small class="mr-1">mdi-close</v-icon>Cancel</v-btn
          >
          <v-btn
            small
            class="mr-2 borderRadius"
            color="secondary"
            @click="changeStatus()"
            :loading="loading"
            ><v-icon small class="mr-1">mdi-check</v-icon>Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/Snackbar.vue";
import { ActivateOrDeactivateCountry } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
export default {
  props: {
    dialogActivateInactivateCountry: Boolean,
    StoreObj: Object,
  },
  components: {
    Snackbar,
  },
  data: () => ({
    Toggle: 0,
    loading: false,
    SnackBarComponent: {},
  }),
  methods: {
    async changeStatus() {
      try {
        var inputParams = {
          country_name: this.StoreObj.country_name,
          country_status:
            this.StoreObj.country_status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
        };
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(ActivateOrDeactivateCountry, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.ActivateOrDeactivateCountry);
        if (ResultObject.status == "Success") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: ResultObject.Status_Message,
          };
          this.dialogActivateInactivateCountryEmit((this.Toggle = 2));
        }
        this.loading = false;
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.errors[0].message,
        };
        this.loading = false;
      }
    },
    dialogActivateInactivateCountryEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
